import React from 'react';
import Portfolio from '../components/Portfolio';
import ProjectTestimonials from '../components/ProjectTestimonials';
import PortfolioCTA from '../components/PortfolioCTA';

const PortfolioPage = () => {
  return (
    <main className="pt-20">
      <Portfolio />
      <ProjectTestimonials />
      <PortfolioCTA />
    </main>
  );
};

export default PortfolioPage;
